import React from 'react';
import Div100vh from 'react-div-100vh';
import { AnswerOption, Question } from '../../redux/features/questions';
import ModalNavbar from '../common/ModalNavbar';
import AnimatedTimMessage from '../tim/AnimatedTimMessage';
import AnswerOptions from '../chat/AnswerOptions';
import DivButton from '../a11y/DivButton';
import Spacing from '../common/Spacing';
import { t } from '../../utils/i18n';
import H from '../elements/H';
import IconText from '../common/IconText';
import ButtonText from '../elements/ButtonText';
import ControlledFadeAnimation from '../animations/ControlledFadeAnimation';
import { baseXUnit } from '../../styles/theme';

interface SearchResultsFilterModalContentProps {
  title: string;
  close: () => void;
  question: Question;
  onAnswer: (question: Question, answer: AnswerOption | null) => void;
  selectedAnswerOption?: AnswerOption;
}

const SearchResultsFilterModalContent: React.FunctionComponent<
  SearchResultsFilterModalContentProps
> = ({ title, close, question, onAnswer, selectedAnswerOption }) => {
  const [showAnswerOptions, setShowAnswerOptions] = React.useState(false);

  return (
    <Div100vh>
      <div className="search-question-window" data-cy="search-question-modal">
        <ModalNavbar title={title} closeDialog={close} />
        <Spacing top={3} right={2} left={2}>
          <AnimatedTimMessage
            showIcon
            iconActive
            disableAnimation
            onAnimationDone={() => {
              setShowAnswerOptions(true);
            }}
          >
            <H styling="h3" data tag="div">
              {question.questionText}
            </H>
          </AnimatedTimMessage>
        </Spacing>
        <div className="bottom">
          <Spacing top={2} right={2} bottom={4} left={2}>
            <ControlledFadeAnimation show={showAnswerOptions}>
              <AnswerOptions
                question={{
                  options: question.options,
                  onAnswer: (option: AnswerOption) => {
                    onAnswer(question, option);
                    close();
                  }
                }}
                selectedAnswerOption={selectedAnswerOption}
              />
              <div
                className="clear-button"
                data-cy="search-question-modal-clear-button"
              >
                <Spacing top={2}>
                  <DivButton
                    onClick={() => {
                      onAnswer(question, null);
                      close();
                    }}
                  >
                    <IconText icon="travel-no" iconColor="purple-light">
                      <ButtonText variant="primary">
                        {t('Poista suodatus')}
                      </ButtonText>
                    </IconText>
                  </DivButton>
                </Spacing>
              </div>
            </ControlledFadeAnimation>
          </Spacing>
        </div>
      </div>
      {/*language=CSS*/}
      <style jsx>{`
        .search-question-window {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        .bottom {
          margin-top: auto;
        }
        .clear-button {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          padding: ${baseXUnit(1)} ${baseXUnit(2)};
        }
      `}</style>
    </Div100vh>
  );
};

export default SearchResultsFilterModalContent;
